import {deliveryApi} from "@/axios";
//通用api
//登录
export function login(data) {
    return deliveryApi({
        url: '/login',
        method: 'post',
        data: data
    })
}
//登出
export function logout() {
    return deliveryApi({
        url: '/logout',
        method: 'get',
    })
}
export function flushLogin() {
    return deliveryApi({
        url: '/login/flush',
        method: 'get',
    })
}
//获取验证码
export function sendCode(data) {
    return deliveryApi({
        url: '/sendCode',
        method: 'post',
        data: data
    })
}

//图形验证码
export function getCaptImage() {
    return deliveryApi({
        url: '/captchaImage',
        method: 'get',
        headers: {'Content-type': 'image/png'}
    })
}
//系统版本号
export function getSysUiVersion(){
    return deliveryApi({
        url: '/version/delivery',
        method: 'get',
    })
}
// export function getRawReleaseInfoByProjectSoleKey(data){
//     return deliveryApi({
//         url: '/platform/project/infos/raw-release',
//         method: 'post',
//         data:data
//     })
// }
export function getRawReleaseInfoByProjectSoleKey(data){
    return deliveryApi({
        url: '/platform/project/infos/raw-release-info',
        method: 'post',
        data:data
    })
}
export function getHddCopyDataByProjectSoleKey(key){
    return deliveryApi({
        url: '/platform/project/infos/hdd-img?key='+key,
        method: 'get',
    })
}
